import React from 'react';

const S = ({ children, className = '' }) => (
  <section className={`mb-8 ${className}`}>{children}</section>
);

const H = ({ children }) => (
  <h2 className="font-serif-display text-2xl sm:text-3xl text-gold-gradient font-black mt-8 mb-3">{children}</h2>
);

export default function Terms() {
  return (
    <div data-testid="terms-page" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-[#C0C0C0]">
      <p className="text-xs uppercase tracking-[0.32em] text-[#D4AF37] font-semibold mb-3">Legal</p>
      <h1 className="font-serif-display text-4xl sm:text-5xl font-black">
        <span className="text-gold-gradient">Terms &amp; Conditions</span>
      </h1>
      <p className="mt-4 text-sm text-[#808080]">Last updated: {new Date().toDateString()}</p>

      <S>
        <H>1. Eligibility</H>
        <p>You must be 18 years of age or older and a resident of the Republic of South Africa to play Golden Fish Lottery. Age is verified during signup and again during KYC. Any breach of this clause voids any prize entitlement.</p>
      </S>

      <S>
        <H>2. The Draw</H>
        <p>The weekly Golden Catch draw takes place every Friday at 18:00 SAST. A single winning ticket is drawn from all active tickets purchased between the previous Friday 18:00 SAST and the current draw close. Draws are conducted by a certified RNG.</p>
      </S>

      <S>
        <H>3. Tickets &amp; Refunds</H>
        <p>Tickets are sold at R5.00 each. Purchases are final and non-refundable once completed. Unauthorised chargebacks may result in permanent account termination.</p>
      </S>

      <S>
        <H>4. Payment &amp; Payout</H>
        <p>Payments are processed via AddPay (or a placeholder gateway during beta). Prizes are paid out via EFT to a South African bank account in the winner's own name once KYC verification (ID document + selfie) is complete.</p>
      </S>

      <S>
        <H>5. KYC &amp; POPIA</H>
        <p>By submitting KYC documents you consent to the storage and processing of your personal information in accordance with the Protection of Personal Information Act (POPIA). Documents are retained for regulatory compliance and destroyed upon account closure once obligations are met.</p>
      </S>

      <S>
        <H>6. Prohibited Conduct</H>
        <p>Multiple accounts, use of automated tools, fraudulent payment methods, or false information will result in account suspension and forfeiture of any prizes.</p>
      </S>

      <S>
        <H>7. Liability</H>
        <p>Golden Fish Lottery accepts no liability for indirect or consequential loss arising from your use of the service. Our aggregate liability is limited to the value of tickets purchased in the 30 days preceding a claim.</p>
      </S>

      <S>
        <H>8. Responsible Gambling</H>
        <p>Please play responsibly. Set limits, take breaks, and never gamble more than you can afford. If gambling is affecting your life, call the National Responsible Gambling Programme on <span className="text-[#D4AF37]">0800 006 008</span> or visit responsiblegambling.org.za.</p>
      </S>

      <S>
        <H>9. Licensing</H>
        <p>Golden Fish Lottery is operated under license — Licensed under <span className="text-[#D4AF37]">[License #: Pending]</span>. Applicable South African gambling laws apply.</p>
      </S>

      <S>
        <H>10. Contact</H>
        <p>Questions? Email support@goldenfish.co.za. All disputes fall under the jurisdiction of the courts of the Republic of South Africa.</p>
      </S>
    </div>
  );
}
